<template>
  <div id="subscriptionsComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout class="mb-4" row wrap>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="subscriptionSearch"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search">
        </v-text-field>
        <v-dialog
          v-model="dialog"
          max-width="700px"
          persistent
        >
          <v-btn
            slot="activator"
            color="primary"
            round
            outline
          >
            <v-icon left>card_membership</v-icon>
            {{ $t('subscriptions.add') }}
          </v-btn>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">{{ formTitle }}</h2>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <!--v-layout wrap-->
                  <v-form
                    lazy-validation
                    ref="form"
                    v-model="valid"
                    v-if="editedItem"
                  >
                    <!--v-container-->
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-autocomplete
                            :disabled="isEdit"
                            v-model="editedItem.company_id"
                            :label="$t('general.company')"
                            :items="companies"
                            item-text="name"
                            item-value="id"
                            :rules="rules.required">
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-select
                            v-model="editedItem.plan_id"
                            :label="$t('general.plan')"
                            :items="plans"
                            item-text="name"
                            item-value="id"
                            :rules="rules.required">
                          </v-select>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="editedItem.expiration_date"
                                :label="$t('subscriptions.expiration_date')"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                                :error-messages="errors.expiration_date"
                                :rules="rules.required"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="editedItem.expiration_date"
                              color="primary"
                              @input="menu = false"
                              :locale="$t('general.locale')"></v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                    <!--/v-container-->
                  </v-form>
                <!--/v-layout-->
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                round
                flat
                @click="close">
                {{ $t('general.cancel') }}
              </v-btn>
              <v-btn
                color="primary"
                round
                depressed
                :loading="loading"
                :disabled="loading"
                @click="validate($event)">
                {{ $t('general.save') }}
              </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogdelete"
        max-width="500px"
        persistent>
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">{{ $t('subscriptions.delete') }}</h2>
          </v-toolbar>
          <v-card-text>
           <p v-html="$t('validation.deleteSubscriptionQuestion', { company: editedItem.company.name})"></p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              round
              flat
              @click="closeDelete">{{ $t('general.cancel') }}</v-btn>
            <v-btn
              color="error"
              round
              depressed
              @click="confirmDelete">{{ $t('general.delete') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </v-layout>
        <v-data-table
        :search="subscriptionSearch"
        class="elevations-2"
        :headers="headers"
        :items="subscriptions"
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination">
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th
              class="font-weigth-black white--text"
              v-for="header in props.headers"
              :key="header.text"
              :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)">
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                {{header.text}}
              </h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td width="60px">{{props.item.id}}</td>
            <td class="text-sm-center">{{props.item.company.name}}</td>
            <td class="text-sm-center">{{props.item.plan[0].name}}</td>
            <td class="text-sm-center">{{props.item.plan[0].application.name}}</td>
            <td class="text-sm-center">{{props.item.expiration_date}}</td>
            <td class="text-sm-center">{{props.item.renovation}}</td>
            <td class="text-sm-center">
              <v-chip v-if="props.item.status === vigent"
               :color="colorSuccessChip"
               :text-color="textColor"
               >
                <v-icon>
                  check_circle
                </v-icon>
                {{ $t('subscriptions.vigent') }}
               </v-chip>
               <v-chip v-else-if="props.item.status === toExpire"
                :color="colorWarningChip"
                :text-color="textColor"
               >
                <v-icon>
                  warning
                </v-icon>
                {{ $t('subscriptions.toExpire') }}
               </v-chip>
               <v-chip v-else-if="props.item.status === expired"
                :color="colorErrorChip"
                :text-color="textColor"
               >
                <v-icon>
                  error
                </v-icon>
                {{ $t('subscriptions.expired') }}
               </v-chip>
            </td>
            <td class="justify-center layout px-0">
              <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      outline
                      icon
                      color="info"
                      v-on="on"
                      @click="editItem(props.item)"
                    >
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.edit') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                    outline
                    icon
                    color="error"
                    v-on="on"
                    @click="deleteItemDialog(props.item)"
                  >
                    <v-icon small>delete</v-icon>
                  </v-btn>
                  </template>
                  <span>{{ $t('general.delete') }}</span>
                </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'subscriptionsComponent',
  data () {
    return {
      subscriptionSearch: '',
      vigent: 1,
      toExpire: 2,
      expired: 3,
      colorSuccessChip: 'success',
      colorWarningChip: 'warning',
      colorErrorChip: 'error',
      textColor: 'white',
      valid: false,
      errors: {},
      dialog: false,
      dialogdelete: false,
      loading: false,
      subscriptions: [],
      pagination: {
        descending: true,
        page: 1,
        orderBy: 'created_at',
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      },
      companies: [],
      plans: [],
      editedIndex: -1,
      editedItem: {
        id: null,
        company: {},
        plan: [],
        expiration_date: '',
        plan_id: null,
        company_id: null
      },
      defaultItem: {
        id: null,
        company: {},
        plan: [],
        expiration_date: '',
        plan_id: null,
        company_id: null
      },
      menu: false
    }
  },
  computed: {
    heading () {
      return this.$t('general.subscriptions')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'far fa-address-card fa-fw icon-color'
    },
    rules () {
      return this.$validationRules()
    },
    headers () {
      return [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: true
        },
        {
          text: this.$t('company.name'),
          align: 'center',
          value: 'company.name',
          sortable: true
        },
        {
          text: this.$t('subscriptions.name'),
          align: 'center',
          value: 'plan[0].name',
          sortable: true
        },
        {
          text: this.$t('subscriptions.application'),
          align: 'center',
          value: 'plan[0].application.name',
          sortable: true
        },
        {
          text: this.$t('subscriptions.expiration_date'),
          align: 'center',
          value: 'expiration_date',
          sortable: true
        },
        {
          text: this.$t('subscriptions.renovations'),
          align: 'center',
          value: 'renovation',
          sortable: true
        },
        {
          text: this.$t('general.status'),
          align: 'center',
          value: 'status',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          value: 'name',
          sortable: false
        }
      ]
    },
    formTitle () {
      return this.editedIndex === -1 ? this.$t('subscriptions.add') : this.$t('subscriptions.edit')
    },
    isEdit () {
      return this.editedIndex !== -1
    }
  },
  created () {
    this.get()
  },
  methods: {
    get () {
      this.$emit('get', { context: this })
    },
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    editItem (item) {
      this.editedIndex = this.subscriptions.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItemDialog (item) {
      if (item !== undefined) {
        this.editedIndex = this.subscriptions.indexOf(item)
        this.editedItem = Object.assign({}, item)
      }
      this.dialogdelete = true
    },
    confirmDelete () {
      this.delete(this.editedItem, this.editedIndex)
      this.closeDelete()
      this.close()
    },
    closeDelete () {
      this.dialogdelete = false
      this.loading = false
    },
    close () {
      this.$refs.form.resetValidation()
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.loading = false
      this.errors = {}
    },
    validate () {
      this.errors = {}
      if (this.$refs.form.validate()) {
        this.save()
      }
    },
    save () {
      this.loading = true
      if (this.editedIndex > -1) {
        this.put()
      } else {
        this.post()
      }
    },
    post () {
      this.$emit('postSubscription', {
        item: this.editedItem,
        context: this
      })
    },
    put () {
      this.$emit('putSubscription', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this
      })
    },
    delete () {
      this.$emit('deleteSubscription', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this
      })
    },
    refresh () {
      this.$emit('refresh', {
        context: this
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/subscriptions.component.vue